<template>
    <div>
         <div :style="{
            'background-image': qrCodeUrl ? `url('${qrCodeUrl}')`: '',
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'width': '300px',
            'height': '300px'
        }">
        </div>
        <p>Please print and display the QR code at the registration counter for the patient's quick check-in to your clinic.</p>
        <a :href="qrCodeDownloadUrl" target="_blank" class="btn btn-primary btn-primary-insv">Download QR Code</a>
    </div>
</template>

<script>
import { apiPath } from '@/config';
export default {
    'name': 'ClinicQr',
    data () {
        return {
            'qrCodeUrl': '',
            'qrCodeDownloadUrl': ''
        };
    },
    mounted () {
        this.getQrCode();
    },
    'methods': {
        getQrCode () {
            this.axios.get('Clinic/GetQrCode').then(({ data }) => {
                let checkInCode = data.data.cc;
                let qrPath = data.data.qp;
                this.qrCodeDownloadUrl = `${apiPath}Clinic/DownloadQr?checkInCode=${checkInCode}`;
                this.qrCodeUrl = qrPath;
            });
        }
    }
};
</script>

<style>

</style>
